import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations - Spanish
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esNav from './locales/es/nav.json';
import esDashboard from './locales/es/dashboard.json';
import esOrders from './locales/es/orders.json';
import esPatients from './locales/es/patients.json';
import esSpecialists from './locales/es/specialists.json';
import esMedications from './locales/es/medications.json';
import esSettings from './locales/es/settings.json';
import esWorkflows from './locales/es/workflows.json';
import esSecurity from './locales/es/security.json';
import esProfile from './locales/es/profile.json';
import esClinical from './locales/es/clinical.json';
import esServices from './locales/es/services.json';
import esInventory from './locales/es/inventory.json';
import esLocations from './locales/es/locations.json';
import esReports from './locales/es/reports.json';
import esWhatsapp from './locales/es/whatsapp.json';
import esGeolocation from './locales/es/geolocation.json';
import esOcr from './locales/es/ocr.json';
import esCompliance from './locales/es/compliance.json';
import esRules from './locales/es/rules.json';
import esScheduledTasks from './locales/es/scheduledTasks.json';
import esReviews from './locales/es/reviews.json';
import esScheduling from './locales/es/scheduling.json';
import esDocumentation from './locales/es/documentation.json';

// Import translations - English
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enNav from './locales/en/nav.json';
import enDashboard from './locales/en/dashboard.json';
import enOrders from './locales/en/orders.json';
import enPatients from './locales/en/patients.json';
import enSpecialists from './locales/en/specialists.json';
import enMedications from './locales/en/medications.json';
import enSettings from './locales/en/settings.json';
import enWorkflows from './locales/en/workflows.json';
import enSecurity from './locales/en/security.json';
import enProfile from './locales/en/profile.json';
import enClinical from './locales/en/clinical.json';
import enServices from './locales/en/services.json';
import enInventory from './locales/en/inventory.json';
import enLocations from './locales/en/locations.json';
import enReports from './locales/en/reports.json';
import enWhatsapp from './locales/en/whatsapp.json';
import enGeolocation from './locales/en/geolocation.json';
import enOcr from './locales/en/ocr.json';
import enCompliance from './locales/en/compliance.json';
import enRules from './locales/en/rules.json';
import enScheduledTasks from './locales/en/scheduledTasks.json';
import enReviews from './locales/en/reviews.json';
import enScheduling from './locales/en/scheduling.json';
import enDocumentation from './locales/en/documentation.json';

// Available languages configuration
export const languages = [
  { code: 'es', name: 'Español', flag: '🇪🇸', nativeName: 'Español' },
  { code: 'en', name: 'English', flag: '🇺🇸', nativeName: 'English' },
];

// Resources organized by language and namespace
const resources = {
  es: {
    common: esCommon,
    auth: esAuth,
    nav: esNav,
    dashboard: esDashboard,
    orders: esOrders,
    patients: esPatients,
    specialists: esSpecialists,
    medications: esMedications,
    settings: esSettings,
    workflows: esWorkflows,
    security: esSecurity,
    profile: esProfile,
    clinical: esClinical,
    services: esServices,
    inventory: esInventory,
    locations: esLocations,
    reports: esReports,
    whatsapp: esWhatsapp,
    geolocation: esGeolocation,
    ocr: esOcr,
    compliance: esCompliance,
    rules: esRules,
    scheduledTasks: esScheduledTasks,
    reviews: esReviews,
    scheduling: esScheduling,
    documentation: esDocumentation,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    nav: enNav,
    dashboard: enDashboard,
    orders: enOrders,
    patients: enPatients,
    specialists: enSpecialists,
    medications: enMedications,
    settings: enSettings,
    workflows: enWorkflows,
    security: enSecurity,
    profile: enProfile,
    clinical: enClinical,
    services: enServices,
    inventory: enInventory,
    locations: enLocations,
    reports: enReports,
    whatsapp: enWhatsapp,
    geolocation: enGeolocation,
    ocr: enOcr,
    compliance: enCompliance,
    rules: enRules,
    scheduledTasks: enScheduledTasks,
    reviews: enReviews,
    scheduling: enScheduling,
    documentation: enDocumentation,
  },
};

// Namespaces list for easy reference
export const namespaces = [
  'common',
  'auth',
  'nav',
  'dashboard',
  'orders',
  'patients',
  'specialists',
  'medications',
  'settings',
  'workflows',
  'security',
  'profile',
  'clinical',
  'services',
  'inventory',
  'locations',
  'reports',
  'whatsapp',
  'geolocation',
  'ocr',
  'compliance',
  'rules',
  'scheduledTasks',
  'reviews',
  'scheduling',
  'documentation',
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    defaultNS: 'common',
    ns: namespaces,
    
    supportedLngs: ['es', 'en'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
      convertDetectedLanguage: (lng) => {
        if (!lng) return 'es';
        const base = lng.split('-')[0].split('_')[0].toLowerCase();
        return ['es', 'en'].includes(base) ? base : 'es';
      },
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
    },
  });

export default i18n;
